module.exports = __webpack_public_path__ + "static/media/serv-4.df0e7dc0.jpg";